var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgZomato = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 25,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1 0H22C23.6 0 25 1.4 25 3.1V22c0 1.7-1.4 3.1-3.1 3.1H3A3.1 3.1 0 0 1 0 21.9V3C0 1.4 1.4 0 3.1 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 7v2l-5.5 5.8 4.5-.1-.6 3.3A60.2 60.2 0 0 0 7 18v-2l5.5-5.7H8.2c.3-1 .4-2.1.6-3.3l4.6.1L18 7z",
    fill: "#0b0002"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZomato, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zomato.7c0284b1.svg";
export { ForwardRef as ReactComponent };